import React, { useState, useEffect } from 'react'
    import { Link, useLocation } from 'react-router-dom'
    import { Menu, X, Code2 } from 'lucide-react'

    const Navbar = () => {
      const [isOpen, setIsOpen] = useState(false)
      const [isScrolled, setIsScrolled] = useState(false)
      const location = useLocation()
      const isHomePage = location.pathname === '/'

      useEffect(() => {
        const handleScroll = () => {
          setIsScrolled(window.scrollY > 50)
        }

        if (isHomePage) {
          window.addEventListener('scroll', handleScroll)
          return () => window.removeEventListener('scroll', handleScroll)
        }
      }, [isHomePage])

      const navbarClasses = isHomePage 
        ? `fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
            isScrolled 
              ? 'bg-white/95 backdrop-blur-md shadow-xl border-b-2 border-orange-200' 
              : 'bg-transparent'
          }`
        : 'bg-white shadow-xl sticky top-0 z-50 border-b-2 border-orange-200'

      const textClasses = isHomePage && !isScrolled 
        ? 'text-white drop-shadow-lg' 
        : 'text-gray-900'

      const logoClasses = isHomePage && !isScrolled 
        ? 'text-orange-300 drop-shadow-lg' 
        : 'text-orange-500'

      return (
        <nav data-component-path="client/src/components/Navbar.jsx" data-component-line="1:4" data-component-id="client/src/components/Navbar.jsx:1:4" className={navbarClasses}>
          <div data-component-path="client/src/components/Navbar.jsx" data-component-line="2:6" data-component-id="client/src/components/Navbar.jsx:2:6" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div data-component-path="client/src/components/Navbar.jsx" data-component-line="3:8" data-component-id="client/src/components/Navbar.jsx:3:8" className="flex justify-between items-center h-20">
              <div data-component-path="client/src/components/Navbar.jsx" data-component-line="4:10" data-component-id="client/src/components/Navbar.jsx:4:10" className="flex items-center">
                <Link data-component-path="client/src/components/Navbar.jsx" data-component-line="5:12" data-component-id="client/src/components/Navbar.jsx:5:12" to="/" className="flex items-center space-x-3 group">
                  <div data-component-path="client/src/components/Navbar.jsx" data-component-line="6:14" data-component-id="client/src/components/Navbar.jsx:6:14" className="relative">
                    <Code2 data-component-path="client/src/components/Navbar.jsx" data-component-line="7:16" data-component-id="client/src/components/Navbar.jsx:7:16" className={`h-10 w-10 transition-all duration-300 group-hover:scale-110 ${logoClasses}`} />
                    <div data-component-path="client/src/components/Navbar.jsx" data-component-line="8:16" data-component-id="client/src/components/Navbar.jsx:8:16" className="absolute -inset-1 bg-gradient-to-r from-orange-400 to-pink-500 rounded-full opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
                  </div>
                  <span data-component-path="client/src/components/Navbar.jsx" data-component-line="9:14" data-component-id="client/src/components/Navbar.jsx:9:14" className={`font-display text-3xl font-bold transition-all duration-300 group-hover:scale-105 ${textClasses}`}>
                    Team Vibe
                  </span>
                </Link>
              </div>

              {/* Desktop Navigation */}
              <div data-component-path="client/src/components/Navbar.jsx" data-component-line="10:10" data-component-id="client/src/components/Navbar.jsx:10:10" className="hidden md:flex items-center space-x-8">
                <Link 
                  data-component-path="client/src/components/Navbar.jsx" data-component-line="11:12" data-component-id="client/src/components/Navbar.jsx:11:12"
                  to="/" 
                  className={`font-semibold text-lg transition-all duration-300 hover:scale-105 relative group ${textClasses}`}
                >
                  Home
                  <div data-component-path="client/src/components/Navbar.jsx" data-component-line="12:14" data-component-id="client/src/components/Navbar.jsx:12:14" className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-orange-400 to-pink-500 group-hover:w-full transition-all duration-300"></div>
                </Link>
                <Link 
                  data-component-path="client/src/components/Navbar.jsx" data-component-line="13:12" data-component-id="client/src/components/Navbar.jsx:13:12"
                  to="/contact" 
                  className={`font-semibold text-lg transition-all duration-300 hover:scale-105 relative group ${textClasses}`}
                >
                  Contact
                  <div data-component-path="client/src/components/Navbar.jsx" data-component-line="14:14" data-component-id="client/src/components/Navbar.jsx:14:14" className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-orange-400 to-pink-500 group-hover:w-full transition-all duration-300"></div>
                </Link>
              </div>

              {/* Mobile menu button */}
              <div data-component-path="client/src/components/Navbar.jsx" data-component-line="15:10" data-component-id="client/src/components/Navbar.jsx:15:10" className="md:hidden">
                <button
                  data-component-path="client/src/components/Navbar.jsx" data-component-line="16:12" data-component-id="client/src/components/Navbar.jsx:16:12"
                  onClick={() => setIsOpen(!isOpen)}
                  className={`p-2 rounded-lg transition-all duration-300 hover:scale-110 ${textClasses} hover:bg-white/20`}
                >
                  {isOpen ? <X data-component-path="client/src/components/Navbar.jsx" data-component-line="17:14" data-component-id="client/src/components/Navbar.jsx:17:14" className="h-6 w-6" /> : <Menu data-component-path="client/src/components/Navbar.jsx" data-component-line="17:14" data-component-id="client/src/components/Navbar.jsx:17:14" className="h-6 w-6" />}
                </button>
              </div>
            </div>

            {/* Mobile Navigation */}
            {isOpen && (
              <div data-component-path="client/src/components/Navbar.jsx" data-component-line="18:10" data-component-id="client/src/components/Navbar.jsx:18:10" className="md:hidden absolute top-full left-0 right-0 bg-white/95 backdrop-blur-md shadow-xl border-b-2 border-orange-200">
                <div data-component-path="client/src/components/Navbar.jsx" data-component-line="19:12" data-component-id="client/src/components/Navbar.jsx:19:12" className="px-4 py-6 space-y-4">
                  <Link 
                    data-component-path="client/src/components/Navbar.jsx" data-component-line="20:14" data-component-id="client/src/components/Navbar.jsx:20:14"
                    to="/" 
                    className="block text-gray-900 font-semibold text-lg hover:text-orange-500 transition-colors duration-300"
                    onClick={() => setIsOpen(false)}
                  >
                    Home
                  </Link>
                  <Link 
                    data-component-path="client/src/components/Navbar.jsx" data-component-line="21:14" data-component-id="client/src/components/Navbar.jsx:21:14"
                    to="/contact" 
                    className="block text-gray-900 font-semibold text-lg hover:text-orange-500 transition-colors duration-300"
                    onClick={() => setIsOpen(false)}
                  >
                    Contact
                  </Link>
                </div>
              </div>
            )}
          </div>
        </nav>
      )
    }

    export default Navbar